import React from "react";
import FadeUp from "components/FadeUp";
import useScreenMobile from "hooks/useScreenMobile";

import "./awardsBanner.scss";

const AwardsBanner = ({
  desktopBannerImage,
  tabBannerImage,
  mobileBannerImage,
  heading,
  paragraph
}) => {
  const isTab = useScreenMobile({ size: 992 });
  const isMobile = useScreenMobile({ size: 568 });

  const desktopStyle = {
    backgroundImage: `url(${desktopBannerImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center center"
  };

  const tabStyle = {
    backgroundImage: `url(${tabBannerImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center center"
  };

  // const mobileStyle = {
  //   backgroundImage: `url(${mobileBannerImage})`,
  //   backgroundSize: "cover",
  //   backgroundPosition: "center center"
  // };

  return (
    <section
      className="awardsBannerDesktop"
      style={isMobile ? {} : isTab ? tabStyle : desktopStyle}
    >
      {isMobile && (
        <img
          src={mobileBannerImage}
          alt="Awards Banner"
          className="mobileBannerImage"
          loading="lazy"
        />
      )}
      <div className="container awardsBannerDesktopContainer">
        <FadeUp>
          <div
            className={
              isMobile
                ? "awardsMobileBanner"
                : isTab
                  ? "awardsTabBanner"
                  : "awardsBannerDescription"
            }
          >
            <div className="awardsBannerHeading">
              <h2 dangerouslySetInnerHTML={{ __html: heading }} />
            </div>
            <p>{paragraph}</p>
          </div>
        </FadeUp>
      </div>
    </section>
  );
};

export default AwardsBanner;
